<template>
  <div>
    <o-table :enable-new="hasPermission(['POST api/sandoz/pv/contracts/{id}'])"
      :enable-edit="false"
      :title="$t('sandoz.pv_contracts')"
      ref="tableList"
      url="/api/sandoz/pv/contracts"
      default-sort-by-direction="desc"
      default-sort-by="id"
    >
      <template slot="filter">
        <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
          <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
          <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
          <o-filter-text :title="$t('sandoz.responsible_sales_person')" column="responsible_sales_person"></o-filter-text>
          <o-filter-select :items="status" :title="$t('sandoz.status')" column="status"></o-filter-select>
          <o-filter-select :items="years" :title="$t('sandoz.contract_year')" column="contract_year"></o-filter-select>
          <o-filter-text :title="$t('sandoz.company_name')" column="company_name"></o-filter-text>
          <o-filter-text :title="$t('sandoz.name')" column="name"></o-filter-text>
          <o-filter-text :title="$t('sandoz.address')" column="address" :placeholder="$t('sandoz.street_zip_city')"></o-filter-text>
        </o-filter>
      </template>
      <template slot="head">
        <o-table-header column="contract_no">{{$t('sandoz.contract_no')}}</o-table-header>
        <o-table-header column="customer_external_id">{{$t('sandoz.customer_external_id')}}</o-table-header>
        <o-table-header :sortable="false">{{$t('sandoz.company_name')}}</o-table-header>
        <o-table-header column="responsible_sales_person">{{$t('sandoz.responsible_sales_person')}}</o-table-header>
        <o-table-header column="status">{{$t('sandoz.status')}}</o-table-header>
      </template>
      <template slot="body" slot-scope="props">
        <td>{{ props.item.contract_no }}</td>
        <td>{{ props.item.customer_external_id }}</td>
        <td>{{ props.item.company_name }}</td>
        <td>{{ props.item.responsible_sales_person }}</td>
        <td>
          <span v-if="props.item.status == 'Feedback' || props.item.status == 'Rejected'" class="text-danger">
            {{ $t('sandoz.' + props.item.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase()) }}
            <fa icon="info-circle" @click.prevent="showFeedback(props.item)"></fa>
          </span>
          <span v-else>
            {{ $t('sandoz.' + props.item.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase()) }}
          </span>
        </td>
      </template>
      <template slot="body-controls" slot-scope="props">
        <td class="text-right">
          <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
            <o-delete method="delete" :url="'/api/sandoz/pv/contracts/' + props.item.id"
                      v-on:action-executed="$refs.tableList.search"></o-delete>
            <router-link :to="{ path: $route.path + '/' + props.item.id }" class="btn btn-primary"
                         v-if="(props.item.status === 'Draft' || props.item.status === 'Feedback') && hasPermission(['POST api/sandoz/pv/contracts/{id}'])">
              <fa icon="pencil-alt"/>
            </router-link>
            <router-link :to="{ path: $route.path + '/view/' + props.item.id }" class="btn btn-primary" v-else>
              <fa icon="eye"/>
            </router-link>
          </div>
        </td>
      </template>
    </o-table>
    <approver-modal ref="approverModal" :contract="contract"/>
  </div>
</template>


<script>
  import {mapGetters} from 'vuex'
  import axios from 'axios'
  import ApproverModal from '../partials/ApproverModal.vue'
  import { contractYears } from '../../../utils/contractYear'

  export default {
    components: {
      ApproverModal
    },
    data: () => ({
      status: [],
      years: [],
      previousContract: [],
      contract: null
    }),
    created() {
      this.years = contractYears()

      this.status = [
        {value: 'Planned', text: this.$i18n.t('sandoz.planned')},
        {value: 'Draft', text: this.$i18n.t('sandoz.draft')},
        {value: 'Committed', text: this.$i18n.t('sandoz.committed')},
        {value: 'Signed', text: this.$i18n.t('sandoz.signed')},
        {value: 'Lost', text: this.$i18n.t('sandoz.lost')},
        {value: 'Cancelled', text: this.$i18n.t('sandoz.cancelled')},
        {value: 'ZeroInvest', text: this.$i18n.t('sandoz.zero_invest')},
        {value: 'Feedback', text: this.$i18n.t('sandoz.feedback')},
        {value: 'Rejected', text: this.$i18n.t('sandoz.rejected')},
        {value: 'Approved', text: this.$i18n.t('sandoz.approved')}
      ]
      this.previousContract = [
        {value: 'Yes', text: this.$i18n.t('sandoz.yes') },
        {value: 'No', text: this.$i18n.t('sandoz.no')}
      ]
    },
    computed: {
      ...mapGetters({
        user: 'auth/user'
      })
    },
    methods: {
      hasPermission(item) {
        let result = true
        let permissions = item
        let user = this.user
        if (!user.is_super_user && permissions) {
          permissions.forEach((permission) => {
            if (!user.routePermissions.includes(permission)) {
              result = false
            }
          })
        }
        return result
      },
      openApproverModal(contract) {
        this.contract = contract
        this.$refs.approverModal.showDialog()
      },
      showFeedback(item) {
        window.alert(item.approval_feedback)
      },
      closeApproverModal() {
        this.contract = null
        this.$refs.approverModal.hideDialog()
      },
    }
  }
</script>
